import gql from "../gql";
export default gql `
  fragment Progress on UserProgress {
    __typename
    completedPercent
    completedDate
    earnedPoints
    state
  }
`;
